<template>
  <div v-if="user">
    <button
      v-if="user.verified_status === statuses.new"
      @click="emitOpen"
      class="btn verification-desc verification-desc--new"
    >
      {{ trans.get('profile:edit.verify_profile_button') }}
    </button>
    <p
      v-else-if="user.verified_status === statuses.uploaded"
      class="verification-desc verification-desc--in-progress"
      disabled
    >
      {{ trans.get('profile:edit.verification_in_progress') }}
    </p>
    <p
      v-else-if="user.verified_status === statuses.accepted"
      class="verification-desc verification-desc--positive"
    >
      {{ trans.get('profile:edit.profile_verified') }}
    </p>
    <button
      v-else-if="user.verified_status === statuses.rejected"
      @click="emitOpen"
      class="btn verification-desc"
    >
      {{ trans.get('profile:edit.verify_profile_button') }}
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'VerificationStatusButton',
  props: {},
  data() {
    return {
      statuses: {},
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    })
  },
  methods: {
    emitOpen() {
      this.$eventHub.$emit('VerificationStatusOpen', this.profileId);
      // this.$eventHub.$emit('VerificationSMSStatusOpen', this.profileId);
    },
  },
  mounted() {
    this.statuses = window.globals.user_image_verification;
  }
};
</script>

<style scoped>

</style>
